import React from "react";
import "./ConfirmModal.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const ConfirmModal = ({
  isOpen,
  onClose,
  toggleCourseAcceptance,
  selectedUser,
  selectedCourse,
}) => {
  if (!isOpen) return null;

  const handleAccept = () => {
    toggleCourseAcceptance(selectedUser, selectedCourse);
  };

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      dialogClassName="custom-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Access Change</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to change access to the selected course?
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onClose}
          style={{
            backgroundColor: "#fff",
            border: "1px solid #949a9e",
            color: "#949a9e",
          }}
        >
          No
        </Button>
        <Button
          variant="primary"
          onClick={handleAccept}
          style={{
            backgroundColor: "#fff",
            border: "1px solid #d1b794",
            color: "#d1b794",
          }}
        >
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
